import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './../UserAppResource';

class ClientAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'oauthClient';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'oauth/clients';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'secret',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'clientType',
            'name',
            'redirect',
            'presonalAccessClient',
            'passwordClient',
            'revoked',
            'resetUrl',
            'redirectDomains',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            user: UserAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            user: 'user_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            userUuid: {
                type: 'string',
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            secret: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 100,
                },
            },
            redirect: {
                type: 'string',
                length: {
                    minimum: 1,
                },
            },
            redirectDomains: {
                type: 'array',
            },
            personalAccessClient: {
                type: 'boolean',
            },
            passwordClient: {
                type: 'boolean',
            },
            revoked: {
                type: 'boolean',
            },
            resetUrl: {
                type: 'string',
                length: {
                    minimum: 0,
                    maximum: 255,
                },
            },
            createdAt: {
                datetime: true,
            },
            updatedAt: {
                datetime: true,
            },
            clientType: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'system',
                    'product',
                    'partner',
                    '3rd-party',
                    'user',
                ],
            },
        };
    }

}

export default ClientAppResource;
